import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { WebPanelLocationQuery } from './WebPanelLocationQuery.graphql';

export const useConnectAppsData = ({
	contentId,
	location,
}: {
	contentId: string;
	location: string;
}) => {
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		WebPanelLocationQuery,
		{
			variables: {
				contentId,
				location,
			},
			fetchPolicy: 'cache-first',
		},
	);
	const panels = data?.webPanels || [];
	return panels.map((panel) => panel?.moduleKey).join(',');
};
